import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import { useDispatch, useSelector } from 'react-redux'

import OnsiteRightAds from './OnsiteRightAds'
import OnsiteGamContent from './OnsiteGamContent'

import { useIsGamAccountConnectedToRightsHolderAccount } from '../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/hooks'

import { getSelfAccount } from '../../../modules/actions/selfAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../modules/selectors/partnerships'
import { selfAccountWasLoadedSelector } from '../../../modules/selectors/selfAccounts'

const OnsiteRightContent = () => {
  const dispatch = useDispatch()

  const rightHolderAccountId = useSelector(selectedPartnershipRightsHolderIdSelector)
  const selfAccountWasLoaded = useSelector(selfAccountWasLoadedSelector)

  const isGamAccountConnected = useIsGamAccountConnectedToRightsHolderAccount()

  useEffect(() => {
    // Fetch rights holder self account to know if the user has a GAM account connected
    if (!selfAccountWasLoaded) {
      dispatch(getSelfAccount(rightHolderAccountId))
    }
  }, [dispatch, selfAccountWasLoaded, rightHolderAccountId])

  if (!selfAccountWasLoaded) {
    return (
      <>
        <br />
        <Skeleton width={400} />
      </>
    )
  }

  if (isGamAccountConnected) {
    // When GAM account is connected to rights holder account - user can create GAM onsite right
    // and then on right summary page they should see GAM content (GAM upload creative form, campaigns table etc.)
    return <OnsiteGamContent />
  } else {
    return <OnsiteRightAds />
  }
}

export default OnsiteRightContent
